<template>
    <loader v-if="analyticsDataIsLoading" />
    <article
        v-if="analyticsData"
        class="a-as-info-block">
        <article-header :header-data="headerData" />
        <div class="a-as-info-block__wrapper">
            <div class="a-as-info-block__subtitle">
                {{ getLivingSquareSum }}
            </div>
            <p class="a-as-info-block__desc a-as-info-block__desc--less">
                {{ desc_01 }}
            </p>
        </div>
        <div class="a-as-info-block__wrapper">
            <p class="a-as-info-block__desc">
                {{ analyticsData.fundraising.escrowSquareSum.toFixed(1).replace('.', ',') + desc_03 }}&nbsp;&mdash;
            </p>
            <p class="a-as-info-block__desc">
                {{ analyticsData.fundraising.escrowSquarePct.toFixed(1).replace('.', ',') + desc_02 }}
            </p>
        </div>
        <article-footer :footer-data="footerData"/>
    </article>
</template>

<script>
    import ArticleHeader from '../../helpers/ArticleHeader'
    import ArticleFooter from '../../helpers/ArticleFooter'
    import Loader from '../../../vue-components/Loader'
    import {analyticsDataActionTypes} from '../../../store/modules/analytics-data'
    import {mapState} from 'vuex'

    export default {
        name: 'InfoBlock',
        components: {
            ArticleHeader,
            ArticleFooter,
            Loader
        },
        data() {
            return {
                apiUrlAnalytics: '/ajax/analytics.php',
                headerData: {
                    title: 'Строительство в России',
                    date: '',   
                },
                footerData: {
                    source: null,
                    button: {
                        src: 'https://xn--80az8a.xn--d1aqf.xn--p1ai/%D0%B0%D0%BD%D0%B0%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0/%D0%B4%D0%BE%D0%BB%D0%B5%D0%B2%D0%BE%D0%B5_%D1%81%D1%82%D1%80%D0%BE%D0%B8%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D1%82%D0%B2%D0%BE?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_nash.dom.rf_rf_page.button&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/analytics/',
                        title: 'наш.дом.рф',
                        color: 'white-arrow'
                    }
                },
                desc_01: 'площадь строящихся квартир, кв. м',
                desc_02: '% от общего объема строительства',
                desc_03: ' млн кв. м строится с эскроу',
                monthes: [
                    'января',
                    'февраля',
                    'марта',
                    'апреля',
                    'мая',
                    'июня',
                    'июля',
                    'августа',
                    'сентября',
                    'октября',
                    'ноября',
                    'декабря'
                ]
            }
        },

        computed: {
            ...mapState({
                analyticsDataIsLoading: state => state.analyticsData.isLoading,
                analyticsData: state => state.analyticsData.data,
                analyticsDataError: state => state.analyticsData.error,
            }),
            headerData() {
                let headerData = {
                    title: 'Строительство в России',
                    date: `Данные на
                        ${new Date(this.analyticsData.indicators.reportDt).getDate()}
                        ${this.monthes[new Date(this.analyticsData.indicators.reportDt).getMonth()]}
                        ${new Date(this.analyticsData.indicators.reportDt).getFullYear()} года`,   
                }
                return headerData
            },
            getLivingSquareSum () {
                return this.analyticsData.squareIndicators.livingSquareSum
                    .split('.')
                    .join('')
                    .replace(/(\d{1,3})(?=((\d{3})*)$)/g, " $1")
                    .trim()
                    .split(' ')
                    .slice(0, 3)
                    .join(' ')
            }
        },

        mounted() {
            this.$store.dispatch(analyticsDataActionTypes.getAnalyticsData, {apiUrl: this.apiUrlAnalytics})
            let componentParent = document.querySelector('#js--a-indicator-info-block')
            if (!componentParent) {
                componentParent = document.querySelector('#app')
            }
            this.footerData.source = JSON.parse(componentParent.getAttribute('informBlocks')).stroitelstvo_v_rossii.source
        }
    }
</script>